export const ARCHIVED_FIELD = 'archived';
export const AUTHOR_FIELD = 'createdById';
export const KNOWLEDGE_CATEGORY_FIELD = 'knowledgeCategoryId__in';
export const LANGUAGE_FIELD = 'language__eq';
export const ORDER_FIELD = 'order';
export const SEARCH_FIELD = 'name__icontains';
export const STATE_FIELD = 'state';
export const VISIBILITY_FIELD = 'hasContentAccessRules';
export const VISIBILITY_LISTS_FIELD = 'contentAccessRuleIds__in';
export const VISIBILITY_TYPE_FIELD = 'contentAccessRuleTypes__in';
export const KNOWLEDGE_BASE_ID_FIELD = 'knowledgeBaseId';
export const LEGACY_FILTERS_FOR_ARTICLES_COUNT = [AUTHOR_FIELD, KNOWLEDGE_CATEGORY_FIELD, VISIBILITY_FIELD, VISIBILITY_LISTS_FIELD, VISIBILITY_TYPE_FIELD, KNOWLEDGE_BASE_ID_FIELD];
export const LEGACY_FILTERS_FOR_BULK_OPERATIONS = [ARCHIVED_FIELD, AUTHOR_FIELD, KNOWLEDGE_CATEGORY_FIELD, SEARCH_FIELD, STATE_FIELD, VISIBILITY_FIELD, VISIBILITY_LISTS_FIELD, VISIBILITY_TYPE_FIELD, KNOWLEDGE_BASE_ID_FIELD];